import dayjs from 'dayjs';
import { AgentSessionEvent, SessionEventName, TalentUpdatedData } from 'services/Api/Conversation';
import { isTalentPropertyUpdate } from './agentSessionEventHelpers';

const getEventPriority = (event: AgentSessionEvent): number => {
    switch (event.name) {
        case SessionEventName.SummaryGenerated:
            return 2;
        case SessionEventName.TalentUpdated: {
            const data = event.data as TalentUpdatedData;
            if (isTalentPropertyUpdate(data)) {
                return 3;
            }
            return 4;
        }
        case SessionEventName.ConversationLocationChanged:
            return 5;
        case SessionEventName.SessionCompleted:
        default:
            return 6;
    }
};

export const sortAgentSessionEvents = (events: AgentSessionEvent[]): AgentSessionEvent[] => {
    return [...events].sort((a, b) => {
        const timeA = dayjs(a.createdAt).valueOf();
        const timeB = dayjs(b.createdAt).valueOf();

        if (timeA !== timeB) {
            return timeA - timeB;
        }

        const priorityA = getEventPriority(a);
        const priorityB = getEventPriority(b);

        return priorityA - priorityB;
    });
};
